import React, { useEffect, useState } from 'react';
import ContentCard from '../../../Common/Card';
import Icons from '../../../../../components/Common/Icons/Icons';
import MenuIcon from '../../../Layout/Menu/MenuIcon';
import DataTable from '../../../../../components/Common/UI/DataTable';
import { documentsCol, documentsData, IDocumentsData } from '../Data';
import { cn } from '../../../../../utils/styles';
import { Button } from '../../../../../components/Common/UI/Button';
import { usePdfDialogProvider } from '../../../../../context/pdfViewerDialog';
import { IAccountData } from '../../../Layout/Account/Data';

interface DocumentsProps {
  search?: string;
}

type IFilters = 'all' | 'unviewed' | 'tax' | 'statement';

const filters: IFilters[] = ['all', 'unviewed', 'tax', 'statement'];
// const ALLOWED_ACCOUNTS_FOR_USER = ['****4560', '****4565'];
const viewerUpdatesRaw = localStorage.getItem('viewerUpdates');

const ALLOWED_ACCOUNTS_FOR_USER = viewerUpdatesRaw
  ? (JSON.parse(viewerUpdatesRaw).find((u: IAccountData) => u.id === '1')?.selectedAccounts ?? [])
  : ['****4560', '****4564'];

function Documents({ search }: DocumentsProps) {
  const [state, setState] = useState<IDocumentsData[]>(documentsData);
  const [active, setActive] = useState<IFilters>('all');
  const [isAuthorizedUser, setIsAuthorizedUser] = useState(false);
  const { handleOpen } = usePdfDialogProvider();

  useEffect(() => {
    const tempViewers = JSON.parse(localStorage.getItem('tempViewers') || '[]');

    setIsAuthorizedUser(tempViewers.length > 0);
  }, []);

  const handleClick = (payload: IFilters) => {
    setActive(payload);
  };

  useEffect(() => {
    let data = [...documentsData];

    if (isAuthorizedUser) {
      data = data.filter(el => ALLOWED_ACCOUNTS_FOR_USER.includes(el.account));
    }

    if (active === 'unviewed') {
      data = data.filter(el => !el.reviewed);
    } else if (active === 'tax') {
      data = data.filter(el => el.tax);
    } else if (active === 'statement') {
      data = data.filter(el => el.statement);
    }

    if (search?.trim()) {
      const q = search.toLowerCase();

      data = data.filter(
        el =>
          el.account.toLowerCase().includes(q) ||
          el.description.toLowerCase().includes(q) ||
          el.searchKey?.toLowerCase().includes(q) ||
          el.date.toLowerCase().includes(q)
      );
    }

    setState(data);
  }, [active, search, isAuthorizedUser]);

  return (
    <ContentCard
      title="Recent Documents"
      icon={<MenuIcon icon={<Icons.Mail />} className="bg-primary border-primary" variant="white" size="large" />}
      actions={filters.map(el => (
        <Button
          key={el}
          className={cn(
            'px-[10px] rounded-[5px] py-[5px] hover:bg-primary hover:text-white uppercase ' +
              'bg-secondary-10 text-secondary-50 text-sm !h-[28px]',
            {
              'bg-primary border-primary text-white': el === active,
            }
          )}
          onClick={() => handleClick(el)}
        >
          {el}
        </Button>
      ))}
    >
      <DataTable
        responsive
        variant="guidance"
        columns={documentsCol}
        data={state}
        paginationPosition="bottom"
        paginationVariant="guidance"
        initialState={{ pagination: { pageSize: 10 } }}
        onRow={({ original }) => handleOpen({ open: true, iframeProps: { src: original.filePath } })}
      />
    </ContentCard>
  );
}

export default Documents;
